import { CommonModule } from "@angular/common";
import { NgModule, inject, provideAppInitializer } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

import { provideApplication } from "@guest-web/core";

import { environment } from "../environments/environment";

import { CoreModule } from "./@core/core.module";
import { InitializationService } from "./@core/services/initialization.service";
import { IntegrationsService } from "./@core/services/integrations.service";
import { MixpanelService } from "./@core/services/mixpanel.service";
import { ThemeService } from "./@core/services/theme.service";
import { LoaderComponent } from "./@shared/common/components/loader/loader.component";
import EncryptionUtil from "./@shared/common/utils/encryption.util";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";

export function initializeApp(initializationService: InitializationService) {
	return (): Promise<any> =>
		new Promise(resolve => {
			EncryptionUtil.generateKey()
				.then(() => {
					initializationService
						.init()
						.then(result => {
							resolve(result);
						})
						.catch(() => {
							resolve(true);
						});
				})
				.catch(() => {
					resolve(true);
				});
		});
}

@NgModule({
	declarations: [AppComponent],
	imports: [
		CommonModule,
		BrowserModule,
		BrowserAnimationsModule,
		CoreModule,
		AppRoutingModule,
		LoaderComponent,
	],
	providers: [
		ThemeService,
		InitializationService,
		IntegrationsService,
		MixpanelService,
		provideApplication({
			channel: environment.channel,
			production: environment.production,
			domains: environment.domains,
			apiMockHost: environment.apiMockHost,
		}),
		provideAppInitializer(() => {
			const initializerFn = initializeApp(inject(InitializationService));
			return initializerFn();
		}),
	],
	bootstrap: [AppComponent],
	exports: [],
})
export class AppModule {}
